// Maps normalized route pathnames to 'Module -> Page Name' labels.
// Split by ' -> ': parts[0] = moduleName, parts[last] = pageName.
// Derived from src/routes/routes.config.js — update this file when new routes are added.
export const PATH_TO_LABEL = {
  // Dashboard
  '/': 'Dashboard -> Home',
  '/dashboard': 'Dashboard -> Dashboard',
  '/Performance': 'Dashboard -> Performance',

  // ProPilot
  '/proship-pilot': 'ProPilot -> ProPilot',

  // Control Tower
  '/control-tower': 'Control Tower -> Control Tower',

  // Shipments (B2C)
  '/orders': 'Shipments -> Forward Shipments',
  '/create-shipment': 'Shipments -> Create Shipment',
  '/create-order': 'Shipments -> Create Forward Shipment',
  '/create-order-rvp': 'Shipments -> Create Reverse Shipment',
  '/bulk-order-create': 'Shipments -> Create Bulk Shipments',
  '/labels-invoices': 'Shipments -> Label, Invoice and Manifest',
  '/download-labels-b2c': 'Shipments -> Bulk Download Labels',
  '/download-invoice': 'Shipments -> Bulk Download Invoice',
  '/download-invoice-label-merge-b2c': 'Shipments -> Bulk Download Label and Invoice (Merged File)',
  '/stuck-orders': 'Shipments -> Unprocessed Shipments',
  '/pending-pickups': 'Shipments -> Manifest',
  '/bulk-tracking': 'Shipments -> Bulk Tracking',
  '/update-payment-mode': 'Shipments -> Update Payment Mode',
  '/orders/create-reverse/:id': 'Shipments -> Create Reverse Shipment',
  '/order-detail': 'Shipments -> Order Detail',
  '/tracking-list': 'Shipments -> Tracking List',
  '/tracking-detail': 'Shipments -> Tracking Detail',
  '/create-order-step2': 'Shipments -> Create Order Step 2',
  '/preview-order': 'Shipments -> Preview Order',

  // PTL Shipments
  '/b2b-orders': 'PTL Shipments -> PTL Shipments',
  '/rate-calculator-ptl': 'PTL Shipments -> Rate Calculator',
  '/create-b2b-orders': 'PTL Shipments -> Create PTL Shipment',
  '/create-mps-orders': 'PTL Shipments -> Create MPS Shipment',
  '/upload-b2b-orders': 'PTL Shipments -> Create Bulk PTL Shipments',
  '/create-pickup-request': 'PTL Shipments -> Create Pickup Request',
  '/ptl-pickup-requests': 'PTL Shipments -> Pickup Requests',
  '/b2b_tracking_upload': 'PTL Shipments -> Upload For Tracking',
  '/ptl-appointment-deliveries': 'PTL Shipments -> Appointment Deliveries',
  '/download-labels-b2b': 'PTL Shipments -> Bulk Download Labels',
  '/ptl-pickup-requests/:id': 'PTL Shipments -> Pickup Request Detail',
  '/ptl-delivery-health': "PTL Delivery Health -> Today's Shipments",
  '/ptl-delivery-health/non-abd-today': 'PTL Delivery Health -> Non-ABD Shipments Due Today',
  '/appointments/overdue': 'ABD PTL Shipments -> Overdue Appointments',
  '/nonabd-edd-breaches': 'Non-ABD PTL Shipments -> EDD Breaches',
  '/ptl-delivery-health/pod-analytics': 'PTL Delivery Health -> PoD Analytics',
  '/ptl-dashboard/performance-overview': 'PTL Dashboard -> Performance Overview',

  // RVP
  '/returns': 'RVP -> RVP',
  '/reverse-orders': 'RVP -> Reverse Shipments',
  '/return-orders': 'RVP -> Return Order Requests',

  // Channel Orders
  '/channel-orders': 'Channel Orders -> Channel Orders',

  // NDR / NPR
  '/ndr': 'NDR -> NDR',
  '/npr': 'NPR -> NPR',

  // Weight Discrepancy
  '/weight-discrepancy': 'Weight Discrepancy -> Weight Discrepancy',
  '/weight-discrepancy-bulk-action': 'Weight Discrepancy -> Bulk Action',

  // Weight Freeze — one entry per sub-module. The module name is the sidebar
  // parent each one is now reached from, not the module they belong to, so a
  // usage report groups them the way a merchant found them.
  '/weight-freeze-v2': 'Weight Management -> Weight Freeze SOP',
  '/weight-freeze-v2/product-master': 'Settings -> Package master',
  '/weight-freeze-v2/initiate': 'Weight Management -> Weight Freeze',
  '/weight-freeze-v2/dws': 'Weight Management -> DWS data',
  '/weight-freeze-v2/analytics': 'Weight Freeze -> Weight analytics',

  // Tools
  '/serviceable-pincodes': 'Tools -> Check Serviceability',
  '/rate-calculator': 'Tools -> Rate Calculator',
  '/merchant-rules': 'Tools -> Allocation Rules',
  '/zone-mapping': 'Tools -> Download Serviceability',
  '/download-mis-from-awb': 'Tools -> Download MIS from AWB',
  '/sorter-image-download': 'Tools -> Sorter Image Download',
  '/download-pod': 'Tools -> Bulk Download POD',
  '/courier-priority': 'Tools -> Courier Priority',
  '/custom-rule': 'Tools -> Custom Rule',

  // Finance
  '/wallet': 'Finance -> Finance',
  '/billing': 'Finance -> Billing',
  '/merchant-invoice': 'Finance -> Merchant Invoice',
  '/rate-card': 'Finance -> Rate Card',

  // Profile
  '/profile': 'Profile -> Profile',
  '/profile/verfication/:step': 'Profile -> Verification',
  '/change-password': 'Profile -> Change Password',

  // Settings
  '/setting': 'Settings -> Settings',
  '/setting/package': 'Settings -> Package Settings',
  '/merchant-step2': 'Settings -> Pickup Locations',
  '/merchant-step3': 'Settings -> Manage Users',
  '/merchant-preview': 'Settings -> Merchant Preview',
  '/delivery-location': 'Settings -> Delivery Locations',
  '/view-webhook': 'Settings -> View Webhook',
  '/configue-webhook': 'Settings -> Configure Webhook',
  '/cod-on-hold-config': 'Settings -> COD On Hold Config',
  '/email-config': 'Settings -> Email Config',
  '/communication-config': 'Settings -> Communication Config',
  '/notification-config': 'Settings -> Notification Config',
  '/pickup-drop-mapping': 'Settings -> Setup Pickup Drop Mapping',

  // Reports
  '/reports': 'Reports -> Reports',

  // Support
  '/escalation_management': 'Support -> Support',
  '/escalation_management/view': 'Support -> Ticket Detail',
  '/support-v2': 'Support -> Support',
  '/support-v2/view': 'Support -> Ticket Detail',

  // Notifications
  '/notification': 'Notifications -> Notifications',
  '/allupdates': 'Notifications -> All Updates',
}
